<script setup lang="ts">
import { useTranslation } from '@/composables';

const { t } = useTranslation();
</script>

<template>
    <div class="welcome-message text-data-table-content">
        <h1 class="mb-4 font-weight-bold">
            {{ t('chatbot.welcomeTitle') }}
        </h1>
        <h2 class="my-10 font-weight-bold">
            {{ t('chatbot.welcomeSubtitle') }}
        </h2>

        <p class="text-body-1 mb-6 font-weight-light">
            {{ t('chatbot.welcomeIntro') }}
        </p>

        <h3 class="text-h6 mb-3 mt-9 d-flex align-center font-weight-bold">
            {{ t('chatbot.welcomeRfidLive') }}
            <span class="pulse-dot ml-3" />
        </h3>
        <p class="text-body-1 font-weight-light">
            {{ t('chatbot.welcomeRfidLiveDesc1') }}
        </p>
        <p class="text-body-1 mb-6 font-weight-light">
            {{ t('chatbot.welcomeRfidLiveDesc2') }}
        </p>

        <p class="text-body-1 font-weight-bold mb-3 mt-9">
            {{ t('chatbot.welcomeSimplyAsk') }}
        </p>
        <ul class="welcome-ask-list text-body-1 font-weight-light mb-3">
            <li>{{ t('chatbot.welcomeAskItem') }}</li>
            <li>{{ t('chatbot.welcomeAskStock') }}</li>
            <li>{{ t('chatbot.welcomeAskIdle') }}</li>
            <li>{{ t('chatbot.welcomeAskTrends') }}</li>
        </ul>
        <p class="text-body-1 font-weight-bold mt-6">
            {{ t('chatbot.welcomeRetrieveData') }}
        </p>

        <h3 class="text-h6 mt-10 mb-2 font-weight-bold">
            {{ t('chatbot.welcomeTryIt') }}
        </h3>
        <p class="text-body-1 mb-2 font-weight-light">
            {{ t('chatbot.welcomeTryItText') }}
        </p>
        <p class="text-body-1 mb-1 font-weight-light">
            {{ t('chatbot.welcomeForExample') }}
        </p>
        <p class="text-body-1 font-weight-bold">"{{ t('chatbot.welcomeExample1') }}"</p>
        <p class="text-body-1 font-weight-bold">"{{ t('chatbot.welcomeExample2') }}"</p>
    </div>
</template>

<style scoped lang="scss">
.welcome-message {
    margin: 0 auto;
    padding-bottom: 100px;
}

.pulse-dot {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #4caf50;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.6;
        transform: scale(0.85);
    }
}

.welcome-ask-list {
    list-style-type: disc;
    padding-left: 24px;

    li {
        margin-bottom: 8px;
        font-weight: 300;
    }
}
</style>
